import {Component, OnInit, OnDestroy, ViewChild, Input, Output, EventEmitter} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../services/auth.service";
import {MatLegacyTableDataSource as MatTableDataSource} from "@angular/material/legacy-table";
import {MatLegacyPaginator as MatPaginator} from "@angular/material/legacy-paginator";
import {TbbOmniLogFilter} from "./tbbOmniLog.filter";
import { debounceTime } from 'rxjs/operators';
import {LookupService} from "../srvs/lookup";

@Component({
  selector: 'micro-tbbOmniLogs',
  templateUrl: './tbbOmniLogs.component.html'
})
export class TbbOmniLogsComponent implements OnInit, OnDestroy {

  dataSource:MatTableDataSource<any> = new MatTableDataSource<any>();
  filter:TbbOmniLogFilter = new TbbOmniLogFilter();
  selectedRow:any;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  constructor(private auth:AuthService, private env:EnvService, private http:HttpClient, private lookupService:LookupService) {
    this.filter.anyChange.pipe(debounceTime(500)).subscribe(change => {
      this.reload();
    });
  }

  ngOnInit() {
    this.reload();
  }

  ngOnDestroy() {
  }

  public reload() {
    let params:HttpParams = this.filter.getParams()
      .set("page", '' + (this.paginator.pageIndex || 0))
      .set("size", '' + (this.paginator.pageSize || 20))
    ;

    this.http.get(`${this.env.e.url}/tbb/omni/logs`, {params:params}).subscribe(
      data => {
        let page = data as any;
        this.dataSource.data = page.content;
        this.paginator.pageIndex = page.number;
        this.paginator.pageSize = page.size;
        this.paginator.length = page.totalElements;
      }
    );
  }

  selectRow(element) {
    this.selectedRow = element;
    this.selectedRow.reqParsed = JSON.parse(element.req);
    this.selectedRow.rspParsed = JSON.parse(element.rsp);
    this.selectedRow.rawReqParsed = JSON.parse(element.rawReq);
    this.selectedRow.rawRspParsed = JSON.parse(element.rawRsp);
  }
}
